<template>
     <div class="formulario-contacto">
       <mapa></mapa>
        <form id="my_form" v-if="formulario_activo" @submit.prevent="handleSubmit" >
          <div class="form-row">
            <div class="form-group col-sm-12 col-md-6">
              <label for="inputEmail4">NOMBRE Y APELLIDO:</label>
              <input type="text" class="form-control" id="name" placeholder="Nombre" required v-model="name">
            </div>
              <div class="form-group  mt-md-0 col-sm-12 col-md-6">
              <label for="inputEmail4">CORREO:</label>
              <input id="email" class="form-control" placeholder="Email" type="email" required v-model="email">
            </div>
          
          </div>
          <div class="form-row">
                <div class="form-group col-sm-12 col-md-6">
              <label for="inputEmail4">TELEFONO:</label>
              <input type="text" class="form-control" id="subject" placeholder="Asunto" required v-model="subject">
            </div>
            <div class="form-group  col-sm-12 col-md-12">
              <label for="inputEmail4">SU CONSULTA:</label>
                  <textarea id="message" required v-model="message" class="form-control" rows="3"></textarea>
            </div>
          </div>
         <button type="submit" class="btn btn-primary form-group">Enviar</button>
        </form>
        <div class="gracias" v-else>Gracias Estaremos en contacto</div>
    </div>

</template>

     <script>
     import Mapa from './Datos_mapa.vue'
      export default {
         components:{
              mapa:Mapa
          },
        data(){
          return{
            formulario_activo:true,
            name:'',
            email:'',
            subject:'',
            message:''
          }
        },
        methods:{
          handleSubmit(){
            var formdata = new FormData();
            formdata.append( "name", this.name );
            formdata.append( "email", this.email );
            formdata.append( "asunto", this.asunto );
            formdata.append( "message", this.message );
            formdata.append( "template-contactform-submit", "submit" );
            var ajax = new XMLHttpRequest();
            ajax.open( "POST", "/pform/include/sendemail.php" );
            ajax.onreadystatechange = function() {
              if(ajax.readyState == 4 && ajax.status == 200) {
                if(ajax.responseText == "success"){
                  this.formulario_activo = false;
                   } else {
                    console.log("no mando")
                   }
              }
            }
            ajax.send( formdata );
          }
        }
      }

          </script>

<style>
  .gracias{
      text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/contacto/Consultas.vue